export default "__VITE_ASSET__i4ECtbt8__"